import {Component, ViewChild, TemplateRef, ViewEncapsulation,Inject} from "@angular/core";
import { FormControl, Validators} from "@angular/forms";
import { BaseComponent, LoadingTeste} from "../../base-module/base-component/base.component";
import { AuthService } from "../../base-module/base-service/auth.service";
import { fuseAnimations } from "@fuse/animations";
import { TipoCustoService } from "../services/tipo-custo.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface DialogData {
    id: number;
}

@Component({
    selector: "app-cadastro-tipo-custo",
    templateUrl: "./cadastro-tipo-custo.component.html",
    styleUrls: ["./cadastro-tipo-custo.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: []
})

export class CadastroTipoCustoComponent extends BaseComponent {

    descricao = new FormControl("", [Validators.required]);

    model:any = {
        descricao:""
    };

    loadingLocal:any;
    listEstrutura: any[] = [];
    loadingSpinnerEstrutura:boolean = false;

    constructor(public service: TipoCustoService,
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private loading: MatDialog,
                public authService: AuthService,
                public dialogRef: MatDialogRef<CadastroTipoCustoComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData, )
    {
        super(dialog, snackBar);
        if(this.data != null && this.data != undefined){
            this.getById();
        }
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {

        this.loadingLocal =  this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true
        });

    }


    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if(this.loadingLocal !=null){
            this.loadingLocal.close();
        }
    }

    isInvalidForm(){
        if (!this.descricao.valid){
            return true;
        }

        return false;
    }

    salvar(){
        this.openLoading();
        this.model.descricao = this.descricao.value;

        if(this.data == null){

            this.service.create(this.model).subscribe(
                data => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                error => {
                    this.closeLoading();
                    this.showError(error.error.message);

                },
                () => {
                    this.closeLoading();
                }
            );

        }else{

            this.service.update(this.data.id, this.model).subscribe(
                data => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                error => {
                    this.closeLoading();
                    this.showError(error.message);
                },
                () => {                    
                    this.closeLoading();
                }
            );
        }

    }

    getErrorNameMessage() {
        return this.descricao.hasError("required") ? "Nome é um campo obrigatório" : "";
    }

    getById(){
        this.openLoading();
        this.service.getById(this.data.id).subscribe(
         item => {

            this.model = item.data;
            this.descricao.setValue(item.data.descricao);

        },
         error => {
            this.closeLoading();
            console.log(error);
         },
        () => {
            this.closeLoading();
            console.log("complete");
        });
    }

}
